import React, { useEffect, useState } from "react";
import { Flex, Dropdown, Text } from "@fluentui/react-northstar";
import PropTypes from "prop-types";
import { observer } from "mobx-react-lite";
import Constants from "../../../constants/text-constants";

const CallingFromDropdown = observer((props) => {
  const { items, currentCallTeamId, onChange } = props;
  const [renderedItems, setRenderedItems] = useState([]);
  const [selectedCallingFromTeam, setSelectedCallingFromTeam] = useState(null);

  useEffect(() => {
    // sort alphabetically
    items.sort(function (a, b) {
      return a.team.name.localeCompare(b.team.name);
    });

    const allDropdownItems = items.map((item) => {
      return {
        header: item.team.name,
        id: item.team.id,
        selected: item.team.id === currentCallTeamId,
      };
    });
    setRenderedItems(allDropdownItems);
  }, [items, currentCallTeamId]);

  useEffect(() => {
    let teamName = null;

    if (currentCallTeamId) {
      let currentTeam = items.find(
        (item) => item.team.id === currentCallTeamId
      );

      if (currentTeam) {
        teamName = currentTeam.team.name;
      }
    }
    setSelectedCallingFromTeam(teamName);
  }, [items, currentCallTeamId]);

  return (
    <Flex column>
      <Text
        className="body-text"
        data-testid="callingFromDropdownTitle"
        content={Constants.CALLING_FROM}
      />
      <Dropdown
        className="calling-from-dropdown"
        data-testid="callingFromDropdown"
        disabled={items.length <= 1}
        value={selectedCallingFromTeam}
        items={renderedItems}
        placeholder={"Select Team"}
        onChange={(e, item) => onChange(item.value.id)}
        fluid
      />
    </Flex>
  );
});

CallingFromDropdown.propTypes = {
  items: PropTypes.array,
  currentCallTeamId: PropTypes.number,
  onChange: PropTypes.func,
};

CallingFromDropdown.defaultProps = {
  items: [],
};

export default CallingFromDropdown;
